import { isAbortError } from '@mbbe/config';
import { opsSession } from '../../lib/sessions';

export interface OpsMutationOwner {
  /** Account that started the mutation. */
  uid: string | null;
  /** False once that account's session has ended or changed. */
  isCurrent: () => boolean;
}

/**
 * Use as a mutation's `onMutate`: pins the account that started the action so
 * late callbacks can tell whether the UI they would touch still belongs to it.
 */
export const captureOpsMutationOwner = (): OpsMutationOwner => {
  const scope = opsSession.current;
  return { uid: scope.uid, isCurrent: () => scope.isCurrent() };
};

/** A failure that must not surface in the UI: cancelled by a session change or owned by another account. */
export const isStaleMutationError = (error: unknown, owner: OpsMutationOwner | undefined): boolean =>
  isAbortError(error) || owner?.isCurrent() === false;
